import { render, staticRenderFns } from "./exportsinglesheets.vue?vue&type=template&id=6235c18c&scoped=true"
import script from "./exportsinglesheets.vue?vue&type=script&lang=js"
export * from "./exportsinglesheets.vue?vue&type=script&lang=js"
import style0 from "./exportsinglesheets.vue?vue&type=style&index=0&id=6235c18c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6235c18c",
  null
  
)

export default component.exports